import { Link } from "react-router-dom";
import "./AdvertTop.scss";
import { useSelector } from "react-redux";
const AdvertTop = () => {
  const { adds } = useSelector((state) => state.add);

  const adsTop = adds
    ?.filter((ads) => {
      return ads?.category === "Advert Top";
    })
    ?.filter((ads, index) => index < 4);

  return (
    <div className="advertTop">
      <div className="advertTopContainer">
        <div className="left">
          <Link to="/">
            {/* <img src="assets/logo.png" alt="Logo" /> */}
            <h1 className="burn">
              BECKY<span>NEWS</span>{" "}
            </h1>
          </Link>
        </div>
        <div className="right">
          {adsTop.map((ads) => {
            return (
              <Link to={ads.link} target="_blank">
                <img src={ads.image} alt="" />
              </Link>
            );
          })}
          {/* <Link>
            <img src="assets/advertttt.gif" alt="Advertisement" />
          </Link> */}
        </div>
      </div>
    </div>
  );
};
export default AdvertTop;
